import { Container } from "react-bootstrap";
import { PrivacySection, PrivacyWrapper } from "../styles";
import { useEffect, useState } from "react";
import { getPrivacyPolitics } from "../../../../services/manager/admin/settings.service";
import { IPrivacyPolicy } from "../../../../models/IPrivacyPolicy";
import { useTranslation } from "react-i18next";
import { Loader } from "../../../../components/loader";

export const Privacy: React.FC = () => {
	const { t: translate } = useTranslation();

	const [privacyPolicy, setPrivacyPolicy] = useState<IPrivacyPolicy>();

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const privacyPromise = getPrivacyPolitics()
			.then((data) => {
				setPrivacyPolicy(data);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, []);

	return (
		<PrivacyWrapper>
			<h2>{translate("privacy.privacy_policy")}</h2>

			{isLoading && <Loader></Loader>}

			{privacyPolicy &&
				privacyPolicy.is_public &&
				privacyPolicy.body.length > 0 && (
					<PrivacySection>
						<div className="title">
							{translate("privacy.privacy_policy")}
						</div>
						<div
							className="content"
							dangerouslySetInnerHTML={{
								__html: privacyPolicy.body,
							}}
						></div>
					</PrivacySection>
				)}

			{!isLoading && privacyPolicy && !privacyPolicy.is_public && (
				<PrivacySection>
					<p className="p-3">Documento indisponível no momento.</p>
				</PrivacySection>
			)}
		</PrivacyWrapper>
	);
};
